export function repliesQueryKey() {
    return ['replies']
}

export function replyQueryKey(replyId) {
    return ['replies', String(replyId)]
}
